import(/* webpackMode: "eager", webpackExports: ["V2InterviewsScreen"] */ "/app/apps/platform-web/components/v2/screens/V2InterviewsScreen.tsx");
